import { Component, OnInit } from '@angular/core';
import { IconBaseComponent } from '../icon-base/icon-base.component';

@Component({
  selector: 'app-icon-map-pin',
  templateUrl: './icon-map-pin.component.html',
  styleUrls: ['./icon-map-pin.component.scss']
})
export class IconMapPinComponent extends IconBaseComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
